import { addOrUpdateItem, removeItem } from '../../helpers'
import * as types from '../../mutation-types'
import * as Vue from "vue"

export default {
    [types.SET_PROJECTS]: (state, projects) => state.items = projects,
    [types.ADD_OR_UPDATE_PROJECT]: (state, item) => addOrUpdateItem(state, item),
    [types.REMOVE_PROJECT]: (state, item) => removeItem(state, item),
    [types.SET_PROJECTS_TOTAL]: (state, total) => state.total = total,
    [types.SET_CURRENT_PROJECT_ID]: (state, id) => state.currentProjectId = id
}